var items = [];
var trialPackWithRealPlan = {};
var rightPlanVariantsSubscription;

jQuery(document).ready(function () {
	
  var addToCartTrialMansoxSet = document.querySelector('[data-add-to-cart-trial-mansox-set]')
  rightPlanVariantsSubscription = jQuery('.right-plan-variants-subscription');
  var rightPlanStartingFrom = jQuery('.rightPlanStartingFrom');
  
  function calculateStartDate(planName) {
        switch(planName) {
            case 'delivery every 3 months':
                return addMonths(3);
            case 'delivery every 1 month':
                return addMonths(1);
            case 'delivery every 2 months':
                return addMonths(2);
            default:
                // Default to 1 month if no plan name matches
                return addMonths(1);
        }
    }
	
	var defaultPlanName = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('plan-name') || 'default';
    var initial_start_date = calculateStartDate(defaultPlanName);
    rightPlanStartingFrom.html(initial_start_date);
    rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('starting-form', initial_start_date);
	
  // Event handler for changing subscription plan
    jQuery(document).on('change', 'input[name="subscriptionPlan"]', function() {
        if(jQuery(this).is(':checked')) {
            var planName = jQuery(this).data('plan-name');
            var start_date = calculateStartDate(planName);
            rightPlanStartingFrom.html(start_date);
            jQuery(this).data('starting-form', start_date);
        }
    });


  
  jQuery(document).on("click", ".nextAction", function () {
    
    var nextStepCount = parseInt(jQuery(this).attr("data-step-action"));
    var currentStepCount = parseInt(jQuery(this).attr("data-step-action")) -1;
    
    var trialProductId = jQuery('.trialPackProduct').data('trial-pack-id');
    
    if(nextStepCount == 4){
      addItemsToCart(items);
    }else{
      if(nextStepCount == 2){
        setTrialProductData();
        
      }
      if(nextStepCount == 3){
        
        jQuery.when(setRightPlanProductData()).then(updatePlanSummaryHtml())
        
      }
      jQuery('.productOptionsLMP').removeClass('active');
      jQuery('.productOptionsLMP').hide();

      jQuery('[data-step-nav-count=' + currentStepCount + ']').addClass('completed');
      jQuery('[data-step-nav-count=' + currentStepCount + ']').removeClass('active');
      jQuery('[data-step-nav-count=' + nextStepCount + ']').addClass('active');
      
      jQuery('[data-step-content-count=' + nextStepCount + ']').addClass('active');
      jQuery('[data-step-content-count=' + nextStepCount + ']').show();
    }
  });


   jQuery(document).on("click", ".navItemLMH.completed", function () {
        var currentStepCount = parseInt(jQuery(this).attr("data-step-nav-count"));
        for (i = 1; i < 5; i++) {
            if (currentStepCount < i) {
                jQuery('[data-step-nav-count=' + i + ']').removeClass('active');
                jQuery('[data-step-nav-count=' + i + ']').removeClass('completed');
            }
        }

       jQuery('.productOptionsLMP').hide();
       jQuery('[data-step-content-count=' + currentStepCount + ']').addClass('active');
       jQuery('[data-step-content-count=' + currentStepCount + ']').show();
      
       jQuery(this).removeClass('completed');
       jQuery(this).addClass('active');
  });


  var productSliderLMP = jQuery('.productSliderLMP');
    
    productSliderLMP.slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll:1,
      prevArrow: '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0718/0904/0662/files/back.svg?v=1684490771" alt=""></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0718/0904/0662/files/next.svg?v=1684490770" alt=""></button>'
  });

  jQuery("body").bind("DOMNodeInserted", function() {
	var $this = jQuery(this).find('.slick-initialized');
	window.setTimeout(function(){
        $this.addClass('finally-loaded');
    }, 1000);
});
  
  
});


function addMonths(months) {
    const nth = function(d) {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
        }
    }
    var date = new Date();
    date.setMonth(date.getMonth() + +months);
    return date.getDate() + nth(date.getDate()) + " " + date.toLocaleString('default', { month: 'short' }) + " "+ date.getFullYear();
}

function addItemsToCart(items) {
  console.log(items)
    jQuery.ajax({
        type: "POST",
        url: '/cart/clear.js',
        dataType: 'json',
        success: function(){
          jQuery.post('/cart/add.json', {
              items: items
          }).done(function(data, textStatus, jqXHR) {
            
        window.location.href = "/checkout?discount=trial"; 
          }).fail(function(jqXHR, textStatus) {
              alert(jqXHR.responseJSON.errors+' : Store doesn\'t have enough stock yet for the product which you want.')
              console.log('Error - ajax update quantity', jqXHR.responseJSON.errors);
            console.log(jqXHR)
          });
        }
    })
    
}

function setTrialProductData(){
    trialPackWithRealPlan.trial_product = {};
    trialPackWithRealPlan.trial_product.id = jQuery('.trialPackProduct').data('trial-pack-id');
    trialPackWithRealPlan.trial_product.name = jQuery('.trialPackProduct').data('trial-pack-name');
    trialPackWithRealPlan.trial_product.priceWithCurrency = jQuery('.trialPackProduct').data('trial-pack-price-with-currency');
    trialPackWithRealPlan.trial_product.price = jQuery('.trialPackProduct').data('trial-pack-price');
    trialPackWithRealPlan.trial_product.comparePrice = jQuery('.trialPackProduct').data('trial-pack-compare-price');
    trialPackWithRealPlan.trial_product.deliveryPrice = jQuery('.trialPackProduct').data('trial-pack-delivery-price');
    trialPackWithRealPlan.trial_product.deliveryPriceWithCurrency = jQuery('.trialPackProduct').data('trial-pack-delivery-price-with-currency');
}

function setRightPlanProductData(){
    var trialProductId = jQuery('.trialPackProduct').data('trial-pack-id');
    var planId = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('plan-id');
    var planName = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('plan-name');
    var rightPlanVariantSubscriptionId = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('variant-id');
    var rightPlanVariantSubscriptionName = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('variant-name');
    var rightPlanFreeVariantSubscription = '';//rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('free-variant-id');
    var rightPlanVariantSubscriptionPrice = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('variant-price');
    var rightPlanVariantSubscriptionPriceWithCurrency = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('variant-price-with-currency');
    var rightPlanVariantSubscriptionComparePrice = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('variant-compare-price');
    var rightPlanVariantSubscriptionStartDate = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('starting-form');
    var rightPlanVariantSubscriptionDeliveryPrice = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('delivery-price');
    var rightPlanVariantSubscriptionDeliveryPriceWithCurrency = rightPlanVariantsSubscription.find('input[name="subscriptionPlan"]:checked').data('delivery-price-with-currency');

    rightPlanVariantSubscriptionId = rightPlanFreeVariantSubscription ? rightPlanFreeVariantSubscription : rightPlanVariantSubscriptionId;

    trialPackWithRealPlan.real_plan_product = {};
    trialPackWithRealPlan.real_plan_product.planId = planId;
    trialPackWithRealPlan.real_plan_product.planName = planName;
    trialPackWithRealPlan.real_plan_product.name = rightPlanVariantSubscriptionName;
    trialPackWithRealPlan.real_plan_product.id = rightPlanVariantSubscriptionId;
    trialPackWithRealPlan.real_plan_product.price = rightPlanVariantSubscriptionPrice;
    trialPackWithRealPlan.real_plan_product.priceWithCurrency = rightPlanVariantSubscriptionPriceWithCurrency;
    trialPackWithRealPlan.real_plan_product.comparePrice = rightPlanVariantSubscriptionComparePrice;
    trialPackWithRealPlan.real_plan_product.startDate = rightPlanVariantSubscriptionStartDate;
    trialPackWithRealPlan.real_plan_product.deliveryPrice = rightPlanVariantSubscriptionDeliveryPrice;
    trialPackWithRealPlan.real_plan_product.deliveryPriceWithCurrency = rightPlanVariantSubscriptionDeliveryPriceWithCurrency;

    
    items = [];
  /*
    items.push({
      id: trialProductId,
      qty: 1,
    });
  */
    items.push({
      id: rightPlanVariantSubscriptionId,
      qty: 1,
      selling_plan: planId
    });
}

function updatePlanSummaryHtml(){
  jQuery('.trial-pack-summary').find('.trial-pack-name').html(trialPackWithRealPlan.trial_product.name);
  jQuery('.trial-pack-summary').find('.trial-pack-price').html(`${ (trialPackWithRealPlan.trial_product.comparePrice) ? '<del>'+trialPackWithRealPlan.trial_product.comparePrice+'</del>' : '' }<span>${ trialPackWithRealPlan.trial_product.priceWithCurrency }</span>`);
  var trialTotal = parseFloat(trialPackWithRealPlan.trial_product.price)
  if(trialPackWithRealPlan.trial_product.deliveryPrice){
    jQuery('.trialDeliveryLabel').html('DELIVERY');
    jQuery('.trialDeliveryPrice').html(trialPackWithRealPlan.trial_product.deliveryPriceWithCurrency)
    trialTotal = trialTotal + parseFloat(trialPackWithRealPlan.trial_product.deliveryPrice)
  }
  var realPlanTotal = parseFloat(trialPackWithRealPlan.real_plan_product.price)
  if(trialPackWithRealPlan.real_plan_product.deliveryPrice >= 0){
    jQuery('.realPlanDeliveryLabel').html('DELIVERY');
    jQuery('.realPlanDeliveryPrice').html(trialPackWithRealPlan.real_plan_product.deliveryPriceWithCurrency)
    realPlanTotal = realPlanTotal + parseFloat(trialPackWithRealPlan.real_plan_product.deliveryPrice)
  }
  jQuery('.trial-pack-summary').find('.trialPackTotal span').html(trialTotal);
  jQuery('.real-plan-summary').find('.realPlanStartDate').html(trialPackWithRealPlan.real_plan_product.startDate);
  jQuery('.real-plan-summary').find('.realPlanFrequency').html(trialPackWithRealPlan.real_plan_product.planName);
  jQuery('.real-plan-summary').find('.real-plan-name').html(trialPackWithRealPlan.real_plan_product.name);
  jQuery('.real-plan-summary').find('.real-plan-price').html(`${ (trialPackWithRealPlan.real_plan_product.comparePrice) ? '<del>'+trialPackWithRealPlan.real_plan_product.comparePrice+'</del>' : '' }<span>${ trialPackWithRealPlan.real_plan_product.priceWithCurrency }</span>`);
  jQuery('.real-plan-summary').find('.realPlanTotal span').html(realPlanTotal);
  
}
